import { Box, Typography } from "@mui/material";
import { APPS_TITLE } from "../../constants/global.constants";

// svg
import {ReactComponent as IconAlert } from "../../assets/svg/alert-circle.svg";
import {ReactComponent as IconMasterMaker} from "../../assets/svg/app-master-maker.svg";
import {ReactComponent as IconLayoutMaker} from "../../assets/svg/app-layout-maker.svg";
import {ReactComponent as IconBuildingMaker} from "../../assets/svg/app-building-maker.svg";
import {ReactComponent as IconLibrary} from "../../assets/svg/app-library.svg";
import {ReactComponent as IconMembership} from "../../assets/svg/app-membership.svg";
import {ReactComponent as IconOrbit} from "../../assets/svg/app-orbit.svg";



const IconByApp = {
  MASTER: IconMasterMaker,
  LAYOUT: IconLayoutMaker,
  BUILDING: IconBuildingMaker,
  LIBRARY: IconLibrary,
  MEMBERSHIP: IconMembership,
  ORBIT: IconOrbit,
};


export const NoAccessScreen = ({ app }) => {
  const Icon = IconByApp[app];
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          mb: "24px",
        }}
      >
        <Icon width="26px" height="26px" fill="#efa21e" />
        <Typography
          color="primary"
          textAlign={"center"}
          fontSize={"32px"}
          fontWeight={400}
        >
          {APPS_TITLE[app]}
        </Typography>
      </Box>
      <Box
        sx={{
          padding: "40px",
          boxShadow: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
          background: "#FBFBFD",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <Box
            sx={{
              background: "#fcecd2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "62px",
              height: "62px",
              border: "8px solid #fff5e6",
              borderRadius: '50%'
            }}
          >
            <IconAlert stroke="#efa21e" width={"24px"} height={"24px"} />
          </Box>

          <Typography textAlign={"center"} fontSize={"18px"} fontWeight={600}>
            You do not have access to this tool
          </Typography>
          <Typography textAlign={"center"} fontSize={"14px"} fontWeight={400}>
            Please contact your company admin to request access.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
